import React, { useEffect, useState } from "react";

import "./Landing.css";

const isRemoteUrl = (url) => url.startsWith(`http`);

// TODO get sizes of the entire model array
const Landing = ({ onConsent = () => {}, textContent = [``], modelUrl }) => {
  const [fileSize, setFileSize] = useState(null);

  useEffect(() => {
    var xhr = new XMLHttpRequest();
    // "HEAD" instead of "GET", to get only the header
    xhr.open("HEAD", modelUrl, true);
    console.log(modelUrl);
    xhr.onreadystatechange = function () {
      if (this.readyState == this.DONE) {
        setFileSize(parseInt(xhr.getResponseHeader("Content-Length")) / 1e6);
      }
    };
    xhr.send();
  }, [modelUrl]);
  return (
    <div className="landing-screen">
      <div className="landing-screen__container">
        <div className="landing-screen__intro-text">
          <h2>Forensic Architecture 3D Viewer</h2>
          <hr />
          {textContent.map((t, idx) => (
            <p key={`text-${idx}`}>{t}</p>
          ))}
          <p className={`landing-screen__size-notice`}>
            {fileSize &&
              isRemoteUrl(modelUrl) &&
              `This interactive will load 3D models with a total size of ${fileSize.toFixed(
                2
              )}MB(s)`}
            {!isRemoteUrl(modelUrl) && `Loading models locally.`}
          </p>
        </div>
        <div className="landing-screen__button" onClick={onConsent}>
          Continue
        </div>
      </div>
    </div>
  );
};

export default Landing;
